module.exports = __webpack_public_path__ + "static/azhar-f5fe6ded9dd6acf412e4377ab8712583.jpeg";